export default {
  banner: {
    title: "Manufacturing IDaaS solution",
    subtitle:
      "Deeply cultivating advanced manufacturing industries, we build a powerful identity management platform for enterprises, and helping enterprises to eliminate worries in high-speed growth.",
  },
  marquee: {
    item1: {
      title1: "SEER Ltd",
      desc1:
        "SEER is a company that is committed to the intelligence of industrial logistics.",
      title2: "Powerful identity management",
      desc2:
        'We place a high value on the flexibility and reliability of our vendor applications, and Authing"s "Embed, Integrate, Connect" philosophy is a perfect match for our needs. After the partnership, we quickly completed internal employee identity management and external customer identity management with Authing.',
    },
    item2: {
      title1: "Alpha Cen",
      desc1:
        "Alpha Cen is a Silicon Valley-based optical manipulation chip company.",
      title2: "Flexible identity infrastructure",
      desc2:
        "Our experience at Apple and Texas Instruments taught us that unified identity management is important. Authing provided interfaces to the various engineering software and platforms we used, and we were able to build a complete identity infrastructure with very little effort.",
    },
    item3: {
      title1: "Flexiv Ltd",
      desc1:
        "Flexiv Technology is committed to building the third generation of adaptive intelligent robots.",
      title2: "Saving development costs",
      desc2:
        "With the company's growth, we have to purchase various applications, and different third-party vendors have different standards in the identity module. Fortunately, we partnered with Authing early on and were able to bind the vendor directly based on Authing's unified identity management standards, which greatly reduced many of the recurring negotiation costs.",
    },
    item4: {
      title1: "A mega IDM chip vendor",
      desc1:
        "We are dedicated to the design, development, production and sales of DRAM.",
      title2: "Efficient realization of complex needs",
      desc2:
        "Authing is very developer-friendly, with a large number of out-of-the-box APIs and SDKs, detailed developer documentation, and the ability to quickly build reusable products like building blocks even for our very complex internal requirements, which is in line with our technology philosophy.",
    },
    item5: {
      title1: "Life Science Technologies Provider",
      desc1:
        "We are committed to developing innovative vaccines, biological drugs, gene therapies, etc.",
      title2: "Fine-grained authentication forensics",
      desc2:
        "Authing's products are a great fit for our authentication forensics needs in device and hardware management (IoT). Thank you very much for Authing's continued support. I am very impressed with your professionalism and high level of commitment and my team looks forward to a long term partnership with Authing.",
    },
  },
  plight: {
    title: "Why are they building identity systems？",
    desc:
      "Consolidate the foundation of digital identity and eliminate the worries of business expansion",
    itemOne: {
      title: "Lessons from the security mistake",
      desc:
        "The inconsistent identity of applications has seriously affected the business and brought huge security risks, so when I arrived at my current company, the first thing I did was to work with Authing to build a good identity infrastructure and lay a good foundation for subsequent informationization.",
      role: "-- IT Director of an AI robotics company",
    },
    itemTwo: {
      title: "Lessons from experiences in the industry",
      desc:
        "When we saw the news that AMD was hacked to steal 450 GB of data for public extortion due to weak passwords, we chose to work with Authing because of their rich product capability in password management and a full-link audit, which helped us fill the shortage of management very well.",
      role: "-- Head of Information Technology of a chip design company",
    },
  },
  chart: {
    title: "The earlier you build, the lower the cost",
    content1: {
      title: "100 people stage",
      subtitle: "Sharpening the product",
      tooltip: {
        title: "Initial intervention: ",
        content:
          "Proactively building an identity system at the beginning is cost-effective in the long term.",
      },
    },
    content2: {
      title: "1000 people stage",
      subtitle: "Staff expansion",
      tooltip: {
        title: "Mid-stage intervention: ",
        content:
          "The number of people and applications grows and identity system becomes more complex. The time is right for problem solving.",
      },
    },
    content3: {
      title: "10000 people stage",
      subtitle: "Leading the industry",
      tooltip: {
        title: "Late intervention: ",
        content:
          "Forced to build an identity system with high deployment and customization costs and huge investment in manpower costs.",
      },
    },
    content4: {
      title: "100000 people stage",
      subtitle: "Refined Operations",
      tooltip: {
        title: "",
        content: "",
      },
    },
    legend1: {
      text: "Costs invested from early on",
    },
    legend2: {
      text: "Costs invested from mid stages",
    },
    chartTitle: "Cost",
    legendDesc:
      "For actual costs, please refer to the website page Pricing or contact your account manager for an estimate",
  },
  question: {
    title: "Identity management issues of fast growing companies",
    mainTop: {
      title: "Identity security construction lags behind",
      desc:
        "In the process of enterprise development, it is easy to overlook the importance of identity security construction in it, leading to leakage of core knowledge assets.",
      descli1: "No protection for password authentication;",
      descli2: "Less measures for risk control verification;",
      descli3: "Irregular authorization of resources;",
      descli4: "Login information is difficult to trace.",
      desclast: "",
      mobileDesc:
        "Security construction lags behind enterprise development, and highly sophisticated digital assets are highly vulnerable to leakage. When employees log in to each application, the authentication method is not uniform, the password is repeated or too simple, there are no wind control verification measures, and the login information is difficult to trace.",
    },
    mainBottom: {
      item1: {
        title1: "Low AD scalability",
        title2: "",
        contentli1:
          "High prices, complex operations and high demands on corporate budgets and manpower;",
        contentli2:
          "Weak compatibility and incompatibility with emerging applications;",
        contentli3:
          "Single AD multi-domain coupling, multi-domain devices, applications, personnel have the risk of affecting each other.",
        bgImg: "https://files.authing.co/authing-website/manu-5-2-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-2-k.png",
        mobileDesc:
          "The Windows AD authentication system is bloated and weakly scalable, making it difficult to support a large number of emerging B/S architecture applications, and even more difficult to cover business trips and remote office scenarios.",
      },
      item2: {
        title: "Difficulty of data-sync",
        content:
          "Frequent personnel changes in enterprises, the organizational structure between applications can not be synchronized, ",
        contentli1:
          "which will lead to the need for administrators to change the application permissions and structure separately;",
        contentli2:
          "which is too inefficient, and there are security risks caused by the omission of permissions.",
        bgImg: "https://files.authing.co/authing-website/manu-5-3-s.png",
        bgImgDark: "https://files.authing.co/authing-website/manu-5-3-k.png",
        mobileDesc:
          "Frequent personnel changes in enterprises, the organizational structure between applications can not be synchronized, which will lead to the need for administrators to change the application permissions and structure separately, which is too inefficient, and there are security risks caused by the omission of permissions.",
      },
    },
    aside: {
      title: "Data fragmentation",
      desc:
        "The business continues to expand, with new applications being purchased and a large number of old and new applications co-existing.",
      descli1:
        "Multiple and complex systems, using multiple authentication methods;",
      descli2:
        "Multiple sets of organizational structures are difficult to break through;",
      descli3: "It is unable to manage all permissions based on one platform;",
      descli4:
        "Audit information of each application is scattered in different business systems.",
      bgImg: "https://files.authing.co/authing-website/manu-5-4-s.png",
      bgImgDark: "https://files.authing.co/authing-website/manu-5-4-k.png",
      mobileDesc:
        "Business continues to expand, enterprises need to quickly develop or purchase new applications. However, identity fragmentation among applications, repeated authentication when employees log in, difficulty in unified management of information technology staff, and even a large number of zombie accounts, the more development the more difficult to rectify.",
    },
  },
  advantage: {
    item1: {
      title:
        "Build a zero-trust risk control center to guarantee enterprise security",
      desc:
        "Authing helps enterprises unify security management by setting zero-trust access control policies; dynamically raising and lowering authority during the event, conducting real-time and multi-dimensional evaluation and alerting; and conducting comprehensive identity audit, traceability, and analysis afterwards to continuously optimize the risk control engine.",
      alt: "",
    },
    item2: {
      title:
        "Build the identity base to improve employee efficiency and make management more convenient",
      desc:
        "  [] Authing is pre-integrated with a large number of systems commonly used in advanced manufacturing, including OA, ERP, PLM and so on. By opening up the identity system between applications, employees can log in to all applications with privileges; administrators can easily manage the access rights of all applications in a unified manner. ",
      alt: "",
    },
    item3: {
      title: "Automated data-sync to reduce O&M costs and risks",
      desc:
        'Administrators can use the identity system of OA or HR system as the source of identity, and only need to maintain one set of organizational structure in the process of "transferring to and from" employees, which can be synchronized to other applications through Authing. It can be managed in one place and synchronized everywhere, avoiding the hidden problem of missing permission by human operation.',
      alt: "",
    },
    item4: {
      title: "Completing the AD domain shortcomings, more flexible management.",
      desc:
        "Authing supports OIDC, SAML, Oauth, CAS, LDAP and other standard protocols to cover the complete solution of AD to B/S system, and enhance the scalability and convenience for enterprises.",
      alt: "",
    },
  },
  productivity: {
    title: "Choose Authing to increase company's productivity",
    item1: {
      title: "High-security",
      desc1:
        "Data is stored encrypted with AES-256, transmitted encrypted with SSL/TLS.",
      desc2:
        "Provide 7x24 hours of security emergency response; data backup in two locations and three centers.",
      desc3:
        "Obtained multiple certifications such as ISO, Level 3 of Security Protection, Data Protection Regulations, etc.",
    },
    item2: {
      title: "High-performance",
      desc1:
        "Cloud-native: Using Kubernetes containerization technology, supporting minute level elastic expansion and maximum support for billion level user authentication access scenarios.",
      desc2:
        "Cloud-neutral: Maximum compatibility with users' cloud environments, not tied to original cloud vendors.",
    },
    item3: {
      title: "High productivity",
      desc1:
        "Developer friendly: Provide rich login, authentication, authorization API/SDK to reduce R&D cost.",
      desc2:
        "Fast integration with 2000+ mainstream applications, easy and efficient to build identity middleware.",
    },
  },
  other: {
    title: "Want to understand your industry solution deeply?",
    item1: {
      title: "Chip Industry Solutions",
      desc:
        "Unified authentication and authentication for the chip industry to remove security risks and protect core knowledge assets.",
    },
    item2: {
      title: "Robotics Industry Solutions",
      desc:
        "Open the security protection of network, device and identity of the whole chain, and help robotics industry upgrade ",
    },
    item3: {
      title: "Aerospace Solutions",
      desc:
        "Quickly build identity middle office, unified security management, and promote the development of aerospace industry intelligence.",
    },
    item4: {
      title: "Pharmaceutical Industry Solutions",
      desc:
        'For the pharmaceutical and medical equipment industry to quickly achieve compliance and improve the safety and efficiency of the "Internet + medical"',
    },
    downText: "Download",
  },
  download: {
    title: "Submit Form",
    subtitle: "Download the solution now",
    desc: "Select your file to download",
    button: "Download",
    solution: "Download",
  },
};
